import { i18n } from "../../../../../i18n-config";

export const pageview = (url: string) => {
  (window as any)?.dataLayer?.push({
    event: "pageview",
    page: url,
    pageTitle: document.title,
  });
  if (isHomePage(url)) {
    (window as any)?.dataLayer?.push({
      event: "home_page",
      page: url,
      pageTitle: document.title,
    });
  }
};
const isHomePage = (url: string) => {
  const urlTerms = url.split("/");
  if (urlTerms.length === 2 && ["", ...i18n.locales].includes(urlTerms[1]))
    return true;
  return false;
};
